import { connect } from 'react-redux';

import getOrganizationLogo from 'modules/auth/selectors/getOrganizationLogo';

import OrganizationLogo from './OrganizationLogo';

const mapStateToProps = (state) => {
  const { organizationLogo, logoLabel } = getOrganizationLogo(state);

  return {
    organizationLogo,
    logoLabel,
  };
};

export default connect(mapStateToProps)(OrganizationLogo);
